import getAttachmentWellInitialValue from './getAttachmentWellInitialValue';
import initializeAttachments from '../actions/initialization/initializeAttachments';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { MailboxInfo } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';

export default function getAttachmentWellForCompose(
    composeId: string,
    attachmentsToInitialize?: {
        attachments: AttachmentType[];
        mailboxInfo: MailboxInfo;
        parentItemId: ItemId;
        infoBarAddHandler: (
            messageId: string,
            infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
        ) => void;
        infoBarRemoveHandler: (infoBarMessageIds: string[]) => void;
    }
): AttachmentWellViewState {
    const attachmentWellViewState = getAttachmentWellInitialValue(
        false /*isReadOnly*/,
        attachmentsToInitialize === undefined /*isInitialized*/,
        composeId
    );
    if (attachmentsToInitialize) {
        const {
            attachments,
            mailboxInfo,
            parentItemId,
            infoBarAddHandler,
            infoBarRemoveHandler,
        } = attachmentsToInitialize;
        initializeAttachments(
            attachments,
            mailboxInfo,
            attachmentWellViewState,
            true /* forceUpdateAttachmentsInStore */,
            true /* isInitializationForCompose */,
            null,
            parentItemId,
            infoBarAddHandler,
            infoBarRemoveHandler
        );
    }
    return attachmentWellViewState;
}
